import DashboardLayout from 'src/our_pages/Layout/DashboardLayout.vue';
import Login from 'src/our_pages/Login.vue';
import NotFound from 'src/our_pages/NotFoundPage.vue';
import PageTemplate from 'src/our_pages/PageTemplate.vue';
import StaffCompany from 'src/our_pages/StaffCompany.vue';
import StaffTeam from 'src/our_pages/StaffTeam.vue';
import Staff from 'src/our_pages/Staff.vue';
import BP_editor from 'src/our_pages/BP_editor.vue';
import BP_editor_copy from 'src/our_pages/BP_editor_copy.vue';
import BP_page from 'src/our_pages/BP_page.vue';
import BPC_page from 'src/our_pages/BPC_page.vue';
import BP_bkp_page from 'src/our_pages/BP_bkp_page.vue';
import BP_page_edit from 'src/our_pages/BP_page_edit.vue';
import BP_editor_check_list from 'src/our_pages/BP_editor_check_list.vue';
import BP_editor_nopurpose from 'src/our_pages/BP_editor_nopurpose.vue';
import umenuView from 'src/our_pages/umenuView.vue';
import Tasks from 'src/our_pages/Tasks.vue';
import Tasks_editor from 'src/our_pages/Tasks_editor.vue';
import Task from 'src/our_pages/Task.vue';
import InstrForTasks from 'src/our_pages/InstrForTasks.vue';
import Clients from 'src/our_pages/Clients.vue';
import Client from 'src/our_pages/Client.vue';
import Client_history from 'src/our_pages/Client_history.vue';
import Client_chat from 'src/our_pages/Client_chat.vue';
import Client_obj_edit from 'src/our_pages/Client_obj_edit.vue';
import Service_history from 'src/our_pages/Service_history.vue';
import Service_te from 'src/our_pages/TaskEnd_edit.vue';
import Line from 'src/our_pages/Line.vue';
import Line_editor from 'src/our_pages/Line_editor.vue';
import Chat from 'src/our_pages/Chat.vue';
import sso_module from 'src/our_modules/SearchSendObjects/sso_module.vue';
import ObjectNest from 'src/our_modules/SearchSendObjects/ObjectNest.vue';
import CuratorEdit from 'src/our_pages/Curator_edit.vue';
import Guide from 'src/our_pages/Guide.vue';
import Developers from 'src/our_pages/Developers.vue';
import Curator_outer_editor from 'src/our_pages/Curator_outer_editor.vue';
import Docs_editor from 'src/our_pages/Docs_editor.vue';
import ColdCall from 'src/our_pages/ColdCall.vue';
import CallObject from 'src/our_pages/CallObject.vue';
import Services_group_op from 'src/our_pages/Services_group_op.vue';
import Clients_group_op from 'src/our_pages/Clients_group_op.vue';
import Services from 'src/our_pages/Services.vue';
import UnitTests from 'src/our_pages/UnitTests.vue';
import gk_exclude from 'src/our_pages/gk_exclude.vue';
import CellAdd from 'src/our_pages/CellAdd.vue';
import CellRaspred from 'src/our_pages/CellRaspred.vue';
import CellHouseClass from 'src/our_pages/CellHouseClass.vue';
import Helpdesk from 'src/our_pages/Helpdesk.vue';
import HelpdeskStaff from 'src/our_pages/HelpdeskStaff.vue';
import CalendarFull from 'src/our_pages/CalendarFull.vue';
import bp_checklists_editor from 'src/our_pages/BP_checklists_editor.vue';
import menu_editor from 'src/our_pages/Menu_editor.vue'; 

import mo_module from 'src/our_modules/MarketingModule/mo_module.vue';
import MObjectNest from 'src/our_modules/MarketingModule/MObjectNest.vue';
import MarketingPlanObjects from 'src/our_modules/MarketingModule/MarketingPlanObjects.vue';
import MObj_history from 'src/our_pages/MObj_history.vue';

import MarketingPlanAdd from 'src/our_modules/MarketingModule/MarketingPlanAdd.vue';
import MarketingSites from 'src/our_modules/MarketingModule/MarketingSites.vue';
import MarketingPlanAccess from 'src/our_modules/MarketingModule/MarketingPlanAccess.vue';

import Districts_editor from 'src/our_pages/Districts_editor.vue';
import Metros_editor from 'src/our_pages/Metros_editor.vue';

import ExternalCalls from 'src/our_pages/ExternalCalls.vue';
import TicketSystem from 'src/our_pages/TicketSystem.vue';
import TicketSystemFaq from 'src/our_pages/TicketSystemFaq.vue';
import TicketSystemFaqItem from 'src/our_pages/TicketSystemFaqItem.vue';
import ReCardTicketFaqEdit from 'src/our_components/ReCardTicketFaqEdit.vue';

import Ticket from 'src/our_pages/Ticket.vue';

import adsSourceExtendMap from 'src/our_pages/adsSourceExtendMap.vue';
import adsSourceExtendMapEdit from 'src/our_pages/adsSourceExtendMapEdit.vue';

import BillingPage from 'src/our_pages/BillingPage.vue';
import BillKassaPage from 'src/our_pages/BillKassa.vue';
import BillCorrection from 'src/our_pages/BillCorrection.vue';

import KafkaTopics from 'src/our_pages/KafkaTopics.vue';
import Moderation_list_editor from 'src/our_pages/Moderation_list_editor.vue';
import Phone_whitelist_editor from 'src/our_pages/Phone_whitelist_editor.vue';
import Phonebook_editor from 'src/our_pages/Phonebook_editor.vue';

import Watermark from 'src/our_pages/Watermark.vue';
import CallCenter from 'src/our_pages/CallCenter.vue';
import LeadEdit from 'src/our_pages/LeadEdit.vue';
import LeadObject from 'src/our_pages/LeadObject.vue';

import Timetable_editor from 'src/our_pages/Timetable_editor.vue';
import Analytics from 'src/our_pages/Analytics.vue'; // уничтожил Сосновский, затерев в редакторе меню

import Blanks_page from 'src/our_pages/Blanks_page.vue';
import Blank_add_page from 'src/our_pages/Blank_add_page.vue';
import ExportFormats from 'src/our_pages/ExportFormats.vue';
import ExFormat from 'src/our_pages/ExFormat.vue';
import ExFormatEdit from '../our_pages/ExFormatEdit.vue';
import media_source_editor from 'src/our_pages/Media_source_editor.vue'; 
import gk_editor from 'src/our_pages/gk_editor.vue'; 
import gk_corpus from 'src/our_pages/gk_corpus.vue'; 
import MarketingPlans from 'src/our_modules/MarketingModule/MarketingPlans.vue'; 
import MarketingErrors from 'src/our_modules/MarketingModule/MarketingErrors.vue'; 
import MarketingPlan from 'src/our_modules/MarketingModule/MarketingPlan.vue'; 
import MarketingSitesTerms from 'src/our_modules/MarketingModule/MarketingSitesTerms.vue';
import CC_MY_BASE from 'src/our_pages/CC_MY_BASE.vue';
import CC_MY_BASE_edit from 'src/our_pages/CC_MY_BASE_edit.vue';
import RECALL_BASE from 'src/our_pages/RECALL_BASE.vue';
// import RECALL_BASE_edit from 'src/our_pages/RECALL_BASE_edit.vue';

import knowledgebase from 'src/our_pages/KnowledgeBase.vue';
import KnowledgeBasePosts from 'src/our_pages/KnowledgeBasePosts.vue';
import ReCardKBPostEdit from 'src/our_components/knowledgebase/ReCardKBPostEdit.vue';
import KnowledgeBasePost from 'src/our_pages/KnowledgeBasePost.vue';
import SitesEditor from '../our_pages/SitesEditor.vue';
import SitesTermsEditor from '../our_pages/SitesTermsEditor.vue';
import SitesEditPage from '../our_pages/SitesEditPage.vue';
import AITest from '../our_pages/AITest.vue';
import AI from '../our_pages/AI.vue';
import REAIPromptList from '../our_components/ai/REAIPromptList.vue';
import REAIPromptDetail from '../our_components/ai/REAIPromptDetail.vue';
import REAILogs from '../our_components/ai/REAILogs.vue';
import Vue3Parent from '../vue3/Vue3Parent.vue';


// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ 'src/our_pages/Dashboard/Dashboard.vue');

const ifAuthenticated = (to, from, next) => {
	//alert(SGVO.isLogined);
	if (SGVO.isLogined) {
		//alert(location.href);
		SGVO.vsff = { v: 3, r: '' };
		next();
		return;
	}
	/*
	let cu  = SGVO.GetGetVar('cu');
	if(cu!="true"){ cu = '';}else{ cu='?cu=true' }
	next('/data/login'+cu);
	*/
	next('/data/login');
}

const routes = [
	{ path: '/', name: 'Авторизация', component: Login },
	{
		path: '/data',
		component: DashboardLayout,
		redirect: '/data/main',
		name: 'Dashboard layout',
		children: [
			{
				path: '/data/menu/:menuname/*',
				name: 'umenu_view',
				component: umenuView,
				meta: {
					pageTitle: 'umenu_view',
					action: Function,
					cur_comp: Object,
				}
			},
			{
				path: '/data/main',
				name: 'Рабочий стол',
				components: { default: Dashboard },
				meta: {
					pageTitle: 'Рабочий стол',
				},
				// props: { default: true }, 
			},
			{
				path: '/data/line',
				name: 'Лента',
				components: { default: Line },
				meta: {
					pageTitle: 'Лента'
				}
			},
			{
				path: '/data/RECALL_BASE',
				name: 'Обзвон покупателей',
				components: { default: RECALL_BASE },
				meta: {
					pageTitle: 'Обзвон покупателей'
				}
			},
			/*
			{
				path: '/data/RECALL_BASE/id/:rc_id/edit',
				name: 'Обзвон базы редактирование',
				components: { default: RECALL_BASE_edit },
				meta: {
					pageTitle: 'Обзвон базы редактирование'
				}
			},
			*/
			{
				path: '/data/CC_MY_BASE',
				name: 'Моя база',
				components: { default: CC_MY_BASE },
				meta: {
					pageTitle: 'Моя база'
				}
			},
			{
				path: '/data/CC_MY_BASE/id/:cc_my_id/edit',
				name: 'Редактирование записи в моей базе',
				components: { default: CC_MY_BASE_edit },
				meta: {
					pageTitle: 'Редактирование записи в моей базе'
				}
			},
  // уничтожил Сосновский, затерев в редакторе меню
			{
				path: '/data/messages',
				name: 'Почта и мессенджеры',
				components: { default: Chat },
				meta: {
					pageTitle: 'Почта и мессенджеры'
				}
			}, // уничтожил Сосновский, затерев в редакторе меню

			{
				path: '/data/line/channel/add',
				name: 'Добавление канала',
				components: { default: Line_editor },
				meta: {
					pageTitle: 'Добавление канала'
				}
			}, // уничтожил Сосновский, затерев в редакторе меню
			{
				path: '/data/line/channel/id/:channel_id/edit',
				name: 'Редактирование канала',
				components: { default: Line_editor },
				meta: {
					pageTitle: 'Редактирование канала'
				}
			}, // уничтожил Сосновский, затерев в редакторе меню
			{
				path: '/data/analytics',
				name: 'Аналитика',
				components: { default: Analytics },
				meta: {
					pageTitle: 'Аналитика'
				},
			},  // уничтожил Сосновский, затерев в редакторе меню
			{
				path: '/data/calendarfull', // Занятость юристов
				name: 'Календарь',
				components: { default: CalendarFull },
				meta: {
					pageTitle: 'Календарь'
				}
			},  // уничтожил Сосновский, затерев в редакторе меню
			// {
			// 	path: '/data/settings/novo_table',
			// 	name: 'Таблица новостроек',
			// 	components: { default: PageTemplate },
			// 	meta: {
			// 		pageTitle: 'Таблица новостроек'
			// 	},
			// },  // уничтожил Сосновский, затерев в редакторе меню
			// {
			// 	path: '/data/settings/access',
			// 	name: 'Доступы',
			// 	components: { default: PageTemplate },
			// 	meta: {
			// 		pageTitle: 'Доступы'
			// 	},
			// },  // уничтожил Сосновский, затерев в редакторе меню

			{
				path: '/data/clients', 
				name: 'Клиенты',
				components: { default: Clients },
				meta: {
					pageTitle: 'Клиенты'
				}
			},
			{
				path: '/data/clients/id/:client_id',
				name: 'Клиент',
				components: { default: Client },
				meta: {
					pageTitle: 'Клиент'
				},
			},
			{
				path: '/data/clients/id/:client_id/history',
				name: 'Клиент история изменений',
				components: { default: Client_history },
				meta: {
					pageTitle: 'Клиент история изменений'
				},
			},
			{
				path: '/data/clients/id/:client_id/chat',
				name: 'Клиент чаты',
				components: { default: Client_chat },
				meta: {
					pageTitle: 'Клиент чаты'
				},
			},
			{
				path: '/data/clients/id/:client_id/edit',
				name: 'Редактирование клиента',
				components: { default: Client },
				meta: {
					pageTitle: 'Редактирование клиента'
				},
			},
			{
				path: '/data/clients/add',
				name: 'Добавление клиента',
				components: { default: Client },
				meta: {
					pageTitle: 'Добавление клиента'
				},
			},
			{
				path: '/data/clients/id/:client_id/object/edit',
				name: 'Редактирование объекта клиента',
				components: { default: Client_obj_edit },
				meta: {
					pageTitle: 'Редактирование объекта клиента'
				},
			},
			{
				path: '/data/billing/my_money', // открывается только из верхнего меню -- балланс
				name: 'Биллинг',
				components: { default: BillingPage },
				meta: {
					pageTitle: 'Биллинг'
				}
			},
			{
				path: '/data/billing/kassa',
				name: 'Касса',
				components: { default: BillKassaPage },
				meta: {
					pageTitle: 'Касса'
				}
			},
			{
				path: '/data/billing/correction',
				name: 'Корректировки',
				components: { default: BillCorrection },
				meta: {
					pageTitle: 'Корректировки'
				}
			},
			{
				path: '/data/tasks',
				name: 'Задачи',
				components: { default: Tasks },
				meta: {
					pageTitle: 'Задачи'
				}
			},
			{
				path: '/data/tasks/add',
				name: 'Добавление задачи',
				components: { default: Tasks_editor },
				meta: {
					pageTitle: 'Добавление задачи'
				}
			},
			{
				path: '/data/tasks/id/:task_id',
				name: 'Задача',
				components: { default: Task },
				meta: {
					pageTitle: 'Задача'
				}
			},
			{
				path: '/data/service/id/:service_id/task-end/id/:te_id/edit',
				name: 'Редактирование исхода',
				components: { default: Service_te },
				meta: {
					pageTitle: 'Редактирование исхода'
				},
			},
			{
				path: '/data/ColdCall',
				name: 'Холодные звонки',
				components: { default: ColdCall },
				meta: {
					pageTitle: 'Холодные звонки'
				}
			},
			{
				path: '/data/ExtCall',
				name: 'Телефония',
				components: { default: ExternalCalls },
				meta: {
					pageTitle: 'Телефония'
				}
			},
			{
				path: '/data/callcenter',
				name: 'Колл-Центр',
				components: { default: CallCenter },
				meta: {
					pageTitle: 'Колл-Центр'
				}
			},
			{
				// path: '/data/callcenter/id/:client_id/edit',
				path: '/data/callcenter/add',
				name: 'Создание лида',
				components: { default: LeadEdit }, // тут должна быть страница лида
				meta: {
					pageTitle: 'Создание лида'
				},
			},
			{
				path: '/data/callcenter/id/:lead_id/edit',
				name: 'Редактирование лида',
				components: { default: LeadEdit },
				meta: {
					pageTitle: 'Редактирование лида'
				},
			},
			{
				path: '/data/callcenter/id/:lead_id',
				name: 'Страница лида',
				components: { default: LeadObject },
				meta: {
					pageTitle: 'Страница лида'
				}
			},
			{
				path: '/data/ColdCall/id/:obj_id',
				name: 'Объект звонков',
				components: { default: CallObject },
				meta: {
					pageTitle: 'Объект звонков'
				}
			},
			{
				path: '/data/staff',
				name: 'Сотрудники | Моя компания',
				components: { default: StaffCompany },
				meta: {
					pageTitle: 'Сотрудники | Моя компания'
				},
				children: [
					/*{
						path: '/data/staff/id/:code',
						name: 'Сотрудник',
						components: { default: Staff },
						meta: {
							pageTitle: 'Сотрудник'
						},
					}*/
				]
			},
			{
				path: '/data/staff/id/:code',
				name: 'Сотрудник',
				components: { default: Staff },
				meta: {
					pageTitle: 'Сотрудник'
				},
			},
			{
				path: '/data/staff/id/:code/edit',
				name: 'Редактирование сотрудника',
				components: { default: Staff },
				meta: {
					pageTitle: 'Редактирование сотрудника'
				},
			},
			{
				path: '/data/staff/id/:code/settings',
				name: 'Редактирование настроек',
				components: { default: Staff },
				meta: {
					pageTitle: 'Редактирование настроек'
				},
			},
			{
				path: '/data/staff/id/:code/roles',
				name: 'Редактирование ролей',
				components: { default: Staff },
				meta: {
					pageTitle: 'Редактирование ролей'
				},
			},
			{
				path: '/data/staff/myteam',
				name: 'Сотрудники | Моя команда',
				components: { default: StaffTeam },
				meta: {
					pageTitle: 'Сотрудники | Моя команда'
				},
			},
			{
				path: '/data/services',
				name: 'Услуги',
				components: { default: Services },
				meta: {
					pageTitle: 'Услуги'
				}
			},
			{
				path: '/data/services/id/:service_id/history',
				name: 'Услуга история изменений',
				components: { default: Service_history },
				meta: {
					pageTitle: 'Услуга история изменений'
				},
			},
			{
				path: '/data/settings',
				name: 'Настройка',
				components: { default: PageTemplate },
				meta: {
					pageTitle: 'Настройка'
				},
			},
			{
				path: '/data/settings/gk_exclude',
				name: 'Исключенные ЖК',
				components: { default: gk_exclude },
				meta: {
					pageTitle: 'исключенные ЖК'
				},
			},
			{
				path: '/data/settings/gk_editor',
				name: 'Редактор ЖК',
				components: { default: gk_editor },
				meta: {
					pageTitle: 'Редактор ЖК'
				},
			},
			{
				path: '/data/settings/gk_editor/id/:gk_name_tr',
				name: 'Редактор корпусов ЖК',
				components: { default: gk_corpus },
				meta: {
					pageTitle: 'Редактор корпусов ЖК'
				},
			},
			{
				path: '/data/settings/bp_checklists_editor',
				name: 'Редактор таблицы чеклистов',
				components: { default: bp_checklists_editor },
				meta: {
					pageTitle: 'Редактор таблицы чеклистов'
				},
			},			
			{
				path: '/data/settings/menu_editor',
				name: 'Редактор таблицы меню',
				components: { default: menu_editor },
				meta: {
					pageTitle: 'Редактор таблицы меню'
				},
			},			
			{
				path: '/data/settings/media_source_editor',
				name: 'Рекламные источники',
				components: { default: media_source_editor },
				meta: {
					pageTitle: 'Рекламные источники'
				},
			},			
			{
				path: '/data/settings/helpdesk',
				name: 'Хелпдески',
				components: { default: Helpdesk },
				meta: {
					pageTitle: 'Хелпдески'
				},
			},
			{
				path: '/data/settings/helpdeskstaff/:hd_id',
				name: 'Члены хелпдеска',
				components: { default: HelpdeskStaff },
				meta: {
					pageTitle: 'Члены хелпдеска'
				},
			},			
			/*{
				path: '/data/settings/curators_table',
				name: 'Таблица кураторов',
				components: { default: PageTemplate },
				meta: {
					pageTitle: 'Таблица кураторов'
				},
			},*/
			{
				path: '/data/settings/curators_table',
				name: 'Таблица кураторов', //Модуль редактирования кураторов
				components: { default: CuratorEdit },
				meta: {
					pageTitle: 'Таблица кураторов'
				},
			},
			{
				path: '/data/settings/bp_editor',
				name: 'Редактор процессов',
				components: { default: BP_editor },
				meta: {
					pageTitle: 'Редактор процессов'
				},
			},
			{
				path: '/data/settings/bp_editor_copy',
				name: 'Редактор процессов COPY',
				components: { default: BP_editor_copy },
				meta: {
					pageTitle: 'Редактор процессов COPY'
				},
			},
			{
				path: '/data/settings/bp_editor/id/:bp_id',
				name: 'Бизнес процесс',
				components: { default: BP_page },
				meta: {
					pageTitle: 'Бизнес процесс'
				},
			},
			{
				path: '/data/settings/bp_editor_bkp/id/:bp_id',
				name: 'Бизнес процесс bkp',
				components: { default: BP_bkp_page },
				meta: {
					pageTitle: 'Бизнес процесс bkp'
				},
			},
			{
				path: '/data/settings/bp_editor_copy/id/:bp_id',
				name: 'Бизнес процесс COPY',
				components: { default: BPC_page },
				meta: {
					pageTitle: 'Бизнес процесс COPY'
				},
			},
			{
				path: '/data/settings/bp_editor/id/:bp_id/check-list',
				name: 'Редактор чек-листа Бизнес процесса',
				components: { default: BP_editor_check_list },
				meta: {
					pageTitle: 'Редактор чек-листа Бизнес процесса'
				},
			},
			{
				path: '/data/settings/bp_editor/id/:bp_id/no-purpose',
				name: 'Редактор не целевого Бизнес процесса',
				components: { default: BP_editor_nopurpose },
				meta: {
					pageTitle: 'Редактор не целевого Бизнес процесса'
				},
			},
			{
				path: '/data/settings/bp_editor/id/:bp_id/edit',
				name: 'Редактор Бизнес процесса',
				components: { default: BP_page_edit },
				meta: {
					pageTitle: 'Редактор Бизнес процесса'
				},
			},
			{
				path: '/data/settings/bp_editor/id/:bp_id/edit/:type/:type_id',
				name: 'Редактор Компонентов Бизнес процесса',
				components: { default: BP_page_edit },
				meta: {
					pageTitle: 'Редактор Компонентов Бизнес процесса'
				},
			},
			{
				path: '/data/settings/bp_editor/add',
				name: 'Создание Бизнес процесса',
				components: { default: BP_page_edit },
				meta: {
					pageTitle: 'Создание Бизнес процесса'
				},
			},
			{
				path: '/data/settings/bp_editor/id/:bp_id/add/:type',
				name: 'Создание Компонентов Бизнес процесса',
				components: { default: BP_page_edit },
				meta: {
					pageTitle: 'Создание Компонентов Бизнес процесса'
				},
			},
			{
				path: '/data/settings/instructions_for_tasks',
				name: 'Инструкции к задачам',
				components: { default: InstrForTasks },
				meta: {
					pageTitle: 'Инструкции к задачам'
				},
			},
			{
				path: '/data/settings/watermark',
				name: 'Watermark',
				components: { default: Watermark },
				meta: {
					pageTitle: 'Watermark'
				},
			},
			{
				path: '/data/module/sso',
				name: 'Модуль подбора объектов',
				components: { default: sso_module },
				meta: {
					pageTitle: 'Модуль подбора объектов'
				},
			},
			{
				path: '/data/module/sso/object/:object_type/:object_id',
				name: 'Страница объекта',
				components: { default: ObjectNest },
				meta: {
					pageTitle: 'Страница объекта'
				},
			},
			/*
			{
				path: '/data/module/sso/object/second/id/:object_id',
				name: 'Страница объекта вторичной недвижимости',
				components: { default: ObjectScndNest },
				meta: {
					pageTitle: 'Страница объекта вторичной недвижимости'
				},
			},
			*/
			{
				path: '/data/module/mo',
				name: 'Мои объекты',
				components: { default: mo_module },
				meta: {
					pageTitle: 'Мои объекты'
				},
			},
			{
				path: '/data/module/mo/object/add',
				name: 'Страница создания объекта',
				components: { default: MObjectNest },
				meta: {
					pageTitle: 'Страница создания объекта'
				},
			},
			{
				path: '/data/module/mo/object/:object_id',
				name: 'Страница рекламного объекта',
				components: { default: MObjectNest },
				meta: {
					pageTitle: 'Объект'
				},
			},
			{
				path: '/data/module/mo/object/:object_id/edit',
				name: 'Страница редактирования объекта',
				components: { default: MObjectNest },
				meta: {
					pageTitle: 'Редактирование объекта'
				},
			},
			{
				path: '/data/module/mo/object/:object_id/history',
				name: 'Объект история изменений',
				components: { default: MObj_history },
				meta: {
					pageTitle: 'Объект история изменений',
					// backCounter: 0
				},
			},
			{
				path: '/data/module/mo/marketing_plan',
				name: 'Реклама объектов',
				components: { default: MarketingPlanObjects },
				meta: {
					pageTitle: 'Реклама объектов'
				},
			},
			{
				path: '/data/module/mo/marketing_plan/add',
				name: 'Добавление рекламного пакета',
				components: { default: MarketingPlanAdd },
				meta: {
					pageTitle: 'Добавление рекламного пакета'
				},
			},
			{
				path: '/data/module/mo/marketing_plan/edit/:plan_id',
				name: 'Редактирование рекламного пакета',
				components: { default: MarketingPlanAdd },
				meta: {
					pageTitle: 'Редактирование рекламного пакета'
				},
			},
			{
				path: '/data/module/mo/marketing_plan/id/:plan_id',
				name: 'Рекламный пакет',
				components: { default: MarketingPlan },
				meta: {
					pageTitle: 'Рекламный пакет'
				},
			},
			{
				path: '/data/module/mo/marketing_plan/access_edit/:plan_id',
				name: 'Редактирование доступа пакета',
				components: { default: MarketingPlanAccess },
				meta: {
					pageTitle: 'Редактирование доступа пакета'
				},
			},
			{
				path: '/data/module/mo/marketing_plan/site/:site_id',
				name: 'Редактирование площадки',
				components: { default: MarketingSitesTerms },
				meta: {
					pageTitle: 'Редактирование площадки'
				},
			},			
			{
				path: '/data/module/mo/marketing_sites/:plan_id',
				name: 'Рекламные площадки',
				components: { default: MarketingSites },
				meta: {
					pageTitle: 'Рекламные площадки'
				},
			},
			{
				path: '/data/marketing/plans',
				name: 'Рекламные пакеты',
				components: { default: MarketingPlans },
				meta: {
					pageTitle: 'Рекламные пакеты'
				},
			},
			{
				path: '/data/marketing/errors',
				name: 'Ошибки в рекламе',
				components: { default: MarketingErrors },
				meta: {
					pageTitle: 'Ошибки в рекламе'
				},
			},
			{
				path: '/data/settings/guide',
				name: 'Справочники',
				components: { default: Guide },
				meta: {
					pageTitle: 'Справочники'
				},
			},
			{
				path: '/data/settings/districts_editor',
				name: 'Редактор районов',
				components: { default: Districts_editor },
				meta: {
					pageTitle: 'Редактор районов'
				},
			},
			{
				path: '/data/settings/metros_editor',
				name: 'Редактор метро',
				components: { default: Metros_editor },
				meta: {
					pageTitle: 'Редактор метро'
				},
			},
			{
				path: '/data/settings/developers',
				name: 'Редактор застройщиков',
				components: { default: Developers },
				meta: {
					pageTitle: 'Редактор застройщиков'
				},
			},
			{
				path: '/data/settings/curator_outer_editor',
				name: 'Редактор внешних кураторов',
				components: { default: Curator_outer_editor },
				meta: {
					pageTitle: 'Редактор внешних кураторов'
				},
			},
			{
				path: '/data/settings/docs_editor', //Маша: редактор файлов блядь чьих? что-то для застройщиков?
				name: 'Редактор файлов',
				components: { default: Docs_editor },
				meta: {
					pageTitle: 'Редактор файлов'
				},
			},
			{
				path: '/data/settings/services_group',
				name: 'Услуги групповые операции',
				components: { default: Services_group_op },
				meta: {
					pageTitle: 'Услуги групповые операции'
				}
			},
			{
				path: '/data/settings/clients_group',
				name: 'Клиенты групповые операции',
				components: { default: Clients_group_op },
				meta: {
					pageTitle: 'Клиенты групповые операции'
				}
			},
			{
				path: '/data/settings/adsSourceExtendMap',
				name: 'Таблица источников',
				components: { default: adsSourceExtendMap },
				meta: {
					pageTitle: 'Таблица источников'
				}
			},
			{
				path: '/data/settings/adsSourceExtendMap/:ads_ex_id',
				name: 'Таблица источников редактирование',
				components: { default: adsSourceExtendMapEdit },
				meta: {
					pageTitle: 'Таблица источников редактирование'
				}
			},
			{
				path: '/data/ut',
				name: 'UnitTests',
				components: { default: UnitTests },
				meta: {
					pageTitle: 'UnitTests'
				}
			},
			{
				path: '/data/cells',
				name: 'Ячейки',
				components: { default: PageTemplate },
				meta: {
					pageTitle: 'Ячейки'
				},
			},
			{
				path: '/data/cells/celladd',
				name: 'Добавление ячейки',
				components: { default: CellAdd },
				meta: {
					pageTitle: 'Добавление ячейки'
				},
			},
			{
				path: '/data/cells/cellraspred',
				name: 'Распределение ячейки',
				components: { default: CellRaspred },
				meta: {
					pageTitle: 'Распределение ячейки'
				},
			},
			{
				path: '/data/cells/cellhouseclass',
				name: 'Классификация домов',
				components: { default: CellHouseClass },
				meta: {
					pageTitle: 'Классификация домов'
				},
			},
			{
				path: '/data/ticketsystem',
				name: 'Служба поддержки',
				components: { default: TicketSystem },
				meta: {
					pageTitle: 'Служба поддержки'
				},
			},
			{
				path: '/data/TicketSystem/faq',
				name: 'Настройка FAQ',
				components: { default: TicketSystemFaq },
				meta: {
					pageTitle: 'Настройка FAQ'
				},
			},
			{
				path: '/data/TicketSystem/faq/id/:faq_id',
				name: 'Страница FAQ',
				components: { default: TicketSystemFaqItem },
				meta: {
					pageTitle: 'Страница FAQ'
				},
			},
			{
				path: '/data/TicketSystem/faq/id/:faq_id/edit',
				name: 'Настройка FAQ edit',
				components: { default: ReCardTicketFaqEdit },
				meta: {
					pageTitle: 'Редактирование FAQ edit'
				},
			},
			{
				path: '/data/ticketsystem/id/:ticket_id',
				name: 'Заявка',
				components: { default: Ticket },
				meta: {
					pageTitle: 'Заявка'
				}
			},
			{
				path: '/data/ticketsystem/add',
				name: 'Создание заявки',
				components: { default: TicketSystem },
				meta: {
					pageTitle: 'Создание заявки'
				},
			},
			{
				path: '/data/settings/kafkatopics',
				name: 'Данные в топиках Кафки',
				components: { default: KafkaTopics },
				meta: {
					pageTitle: 'Данные в топиках Кафки'
				}
			},
			{
				path: '/data/settings/moderation_list_editor',
				name: 'Редактор причин отказа модерации',
				components: { default: Moderation_list_editor },
				meta: {
					pageTitle: 'Редактор причин отказа модерации'
				},
			},
			{
				path: '/data/settings/phone_whitelist_editor',
				name: 'Редактор whitelist телефонов',
				components: { default: Phone_whitelist_editor },
				meta: {
					pageTitle: 'Редактор whitelist телефонов'
				},
			},
			{
				path: '/data/settings/phonebook_editor',
				name: 'Телефонный справочник',
				components: { default: Phonebook_editor },
				meta: {
					pageTitle: 'Телефонный справочник'
				},
			},
			{
				path: '/data/settings/timetable_editor',
				name: 'Редактор расписания',
				components: { default: Timetable_editor },
				meta: {
					pageTitle: 'Редактор расписания'
				},
			},
			{
				path: '/data/blanks',
				name: 'Бланки',
				components: { default: Blanks_page },
				meta: {
					pageTitle: 'Бланки'
				}
			},
			{
				path: '/data/blanks/add',
				name: 'Добавить бланк',
				components: { default: Blank_add_page },
				meta: {
					pageTitle: 'Добавить бланк'
				}
			},
			{
				path: '/data/export',
				name: 'Настройка выгрузок', // список форматов выгрузок
				components: { default: ExportFormats },
				meta: {
					pageTitle: 'Настройка выгрузок'
				},
			},
			{
				path: '/data/export/id/:format_id',
				name: 'Список правил формата',  // список правил в рамках этого формата
				components: { default: ExFormat },
				meta: {
					pageTitle: 'Список правил формата'
				},
			},
			{
				path: '/data/export/id/:format_id/rules/:rule_id', // data/export/format/:id/rules/:rule
				name: 'Редактирование правила выгрузки',  //  форма редактирования правила выгрузки
				components: { default: ExFormatEdit }, //какой дефолт?
				meta: {
					pageTitle: 'Редактирование правила выгрузки'
				},
			},
			{
				path: '/data/knowledgebase',
				name: 'База Знаний',
				components: { default: knowledgebase },
				meta: {
					pageTitle: 'База Знаний'
				}
			},
			{
				path: '/data/knowledgebase/posts/:kb_group',
				name: 'База Знаний посты',
				components: { default: KnowledgeBasePosts },
				meta: {
					pageTitle: 'База Знаний посты'
				}
			},
			{
				path: '/data/knowledgebase/posts/:kb_group/id/:post_id/edit',
				name: 'База Знаний редактирование поста',
				components: { default: ReCardKBPostEdit },
				meta: {
					pageTitle: 'База Знаний редактирование поста'
				}
			},
			{
				path: '/data/knowledgebase/posts/:kb_group/id/:post_id',
				name: 'База Знаний пост',
				components: { default: KnowledgeBasePost },
				meta: {
					pageTitle: 'База Знаний пост'
				}
			},
			{
				path: '/data/sites',
				name: 'Рекламныe сайты',
				components: { default: SitesEditor },
				meta: {
					pageTitle: 'Рекламные сайты'
				},
			},
			{
				path: '/data/sites/:id',
				name: 'Рекламный сайт',
				components: { default: SitesEditPage },
				meta: {
					pageTitle: 'Рекламный сайт'
				},
			},
			{
				path: '/data/sites/:id/terms',
				name: 'Продвижения рекламного сайта',
				components: { default: SitesTermsEditor },
				meta: {
					pageTitle: 'Рекламный сайт'
				},
			},{
				path: '/data/ai-test',
				name: 'это ИИ?',
				components: { default: AITest },
				meta: {
					pageTitle: 'Шо за ИИ?'
				},
			},{
				path: '/data/ai/test',
				name: 'это ИИ?',
				components: { default: AITest },
				meta: {
					pageTitle: 'Шо за ИИ?'
				},
			},{
				path: '/data/ai/prompts/',
				name: 'Тексты для ИИ',
				component: AI,
				children:[
					{
						path: ':id',
						component: REAIPromptDetail,
						name:'Вопрос к ИИ',
						meta: {
							pageTitle: 'ИИ'
						},
					}, {
						path: '',
						component: REAIPromptList,
						name:'Вопросы к ИИ',
						meta: {
							pageTitle: 'ИИ'
						},
					}
				],
				// redirect:'/data/ai/prompts/',
				meta: {
					pageTitle: 'Шо за ИИ?'
				},
			},{
				path: '/data/ai/list/',
				name: 'Тексты для ИИ',
				component: AI,
				children:[
					{
						path: '',
						component: REAILogs,
						name:'Что было в ИИ',
						meta: {
							pageTitle: 'ИИ'
						},
					}
				],
				// redirect:'/data/ai/prompts/',
				meta: {
					pageTitle: 'Шо за ИИ?'
				},
			},{
				path: '/data/vue3/',
				name: 'Подготовкап к миграции на vue3',
				component: Vue3Parent,
				meta: {
					pageTitle: 'Ну что тут?'
				},
			},

		],
		beforeEnter: ifAuthenticated
	},
	{ path: '/data/login', name: 'Вход', component: Login },
	{ path: '*', name: '404', component: NotFound } //эта строка должна быть всегда последняя. т.е. все роуты должны быть описаны до этой строки
];

export default routes;
